import React from 'react';
import { Connect, PropsFromRedux } from './FetchUserWatchersContainer';
import { UserContextType } from '../../../user/user.types';
import { withUser } from '../../../user/UserContext';

type Props = PropsFromRedux & UserContextType;

export class RawFetchUserWatchers extends React.Component<Props> {
  async componentDidMount() {
    const { currentUser, accessPremium, onLoad } = this.props;
    if (accessPremium || currentUser.isExpired) {
      try {
        onLoad();
      } catch (error) {
        throw error;
      }
    }
  }

  render() {
    return null;
  }
}

export const FetchUserWatchers = withUser(Connect(RawFetchUserWatchers));
